import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import { defaultThemeProp, tryCatch } from '@pega/cosmos-react-core';
import type { WithAttributes } from '@pega/cosmos-react-core';

const StyledCodeBlock = styled.code(
  ({ theme }) => css`
    display: block;
    background-color: ${theme.base.palette['secondary-background']};
    border-radius: calc(${theme.base['border-radius']} * 0.5);
    box-shadow: inset 0 0 0 0.0625rem
      ${tryCatch(() => rgba(theme.base.palette['foreground-color'], 0.1))};
    padding: ${theme.base.spacing};
    margin-block: ${theme.base.spacing};
    overflow-x: auto;

    &,
    & > span {
      white-space: inherit;
    }
  `
);

StyledCodeBlock.defaultProps = defaultThemeProp;

type CodeBlockProps = WithAttributes<
  'code',
  {
    children: ReactNode;
    language?: string;
  }
>;

const CodeBlock = ({ children, ...restProps }: CodeBlockProps) => {
  return (
    <pre>
      <StyledCodeBlock {...restProps}>{children}</StyledCodeBlock>
    </pre>
  );
};

export default CodeBlock;
